module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjI0MCIgdmlld0JveD0iMCAwIDI0MCAyNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNOTAgMTY0SDE1MlYxMDJIMTgyLjc3M0MxODguMDgyIDEwMiAxOTAuNzc1IDk1LjYxMzUgMTg3LjA3IDkxLjgxMjFMMTIwIDIzTDUyLjkzIDkxLjgxMjFDNDkuMjI0OCA5NS42MTM1IDUxLjkxODIgMTAyIDU3LjIyNjcgMTAySDkwVjE0NU05MCAxOTJIMTUyTTk3IDIxNEgxNDUiIHN0cm9rZT0iI0ZGOEYxRCIgc3Ryb2tlLXdpZHRoPSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/04.svg
// module id = +u2N
// module chunks = 1